import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function getSearchResults ({
	shortSku, searchTerm, pageSize = 10, pageNumber = 1, sortOrder = 1
}) {

	try {

		const query = Object.entries({
			shortSku,
			pageSize,
			pageNumber,
			sort: sortOrder,
			searchterm: searchTerm
		})
			.map(([ key, value ]) => `${key}=${value}`)
			.join('&');
		const url = `${baseURI}/search?${encodeURI(query)}`;
		const response = await baseAPIRequest({
			url,
			params: { method: 'GET' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to get search results: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default getSearchResults;
